import './demosfilter.less'

import {Icon} from '@codeurs/front'
import React, {useEffect, useState} from 'react'
import AnimateHeight from 'react-animate-height'
import {useTranslation} from 'util/i18n'
import {useMediaQuery} from 'util/mediaquery'
import {style} from 'util/style'
import {FilterClear} from 'views/filter/filter'
import {Filtertags, FiltertagsItemType} from 'views/filter/filtertags'
import {Theme} from 'views/theme'

const styles = style('demosfilter', ['item', 'dropdown'])

export const DemosFilter: React.FC<{
	tags: Array<FiltertagsItemType>
	filters: Array<string>
	setFilters: (filters: Array<string>) => void
}> = ({tags, filters, setFilters}) => {
	const [openFilters, setOpenFilters] = useState(true)
	const isIpadLand = useMediaQuery('(min-width: 1024px)')
	const t = useTranslation()

	useEffect(() => {
		setOpenFilters(isIpadLand)
	}, [isIpadLand])

	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<div className={styles('filter')}>
						<a
							onClick={() => setOpenFilters(!openFilters)}
							className={styles('filter-toggle').is({open: openFilters})}
						>
							<span className={styles('filter-toggle-label')}>
								{t('filters.title')}
							</span>
							<span className={styles('filter-toggle-icon')}>
								<Icon icon="chevron-down" />
							</span>
						</a>
						<FilterClear onClear={() => setFilters([])} />
					</div>
					<AnimateHeight height={!openFilters ? 0 : 'auto'}>
						<div className={styles('tags')}>
							<Filtertags
								tags={tags}
								filters={filters}
								toggleTag={key => {
									if (filters.includes(key)) {
										setFilters(filters.filter(filter => filter !== key))
									} else {
										setFilters([...filters, key])
									}
								}}
							/>
						</div>
					</AnimateHeight>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
